import { create } from 'zustand'

export const useOfflineModal = create<{
  isOpen: boolean
  close: () => void
  open: () => void
}>((set) => ({
  isOpen: false,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false }),
}))

export default useOfflineModal
